import { useState, useEffect, useCallback } from "react";
import deptIcon from "../../../../../assets/shapes_svg/ambition/actionplans/production-icon.svg";
import "./index.css";
import { ProductionList } from "./ProductionList";
import {
  createEffort,
  getEfforts,
} from "../../../../../apis/Business/DepartmentEffortApi";
import { useInvalidateQuery } from "../../../../../components/InvalidateQueryContext";
import { ambitionDeptKey } from "../../../../../apis/ApiKey/AmbitionDepartmentKey";
import { Link } from "react-router-dom";

export const ProductionDepartment = ({ department }) => {
  const [efforts, setEfforts] = useState([]);
  const [newEffort, setNewEffort] = useState("");
  const { triggerInvalidate, invalidateKey, resetKey } = useInvalidateQuery();
  const { createEfforts } = ambitionDeptKey;
  const [year, setYear] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setYear(params.get("year"));

    // Optional: Add a listener for URL changes
    const handleUrlChange = () => {
      const params = new URLSearchParams(window.location.search);
      setYear(params.get("year"));
    };

    window.addEventListener("popstate", handleUrlChange);
    return () => window.removeEventListener("popstate", handleUrlChange);
  }, []);

  useEffect(() => {
    fetchEfforts();
  }, [department.id]);

  const fetchEfforts = useCallback(async () => {
    try {
      const fetchedEfforts = await getEfforts(department.id);
      setEfforts(fetchedEfforts);
    } catch (err) {
      console.error("Failed to fetch efforts:", err);
    }
  }, [department.id]);

  const handleSaveEffort = async () => {
    if (newEffort.trim()) {
      try {
        await createEffort({
          departmentId: department.id,
          name: newEffort.trim(),
          triggerInvalidate: triggerInvalidate,
        });
        fetchEfforts();
        setNewEffort("");
      } catch (error) {
        console.error("Failed to create effort:", error);
      }
    }
  };

  useEffect(() => {
    if (invalidateKey === createEfforts) {
      fetchEfforts();
    }
    resetKey();
  }, [createEfforts, fetchEfforts, invalidateKey, resetKey]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-start",
        gap: "15px",
        width: "100%",
      }}
    >
      <Link
        className="nav-link"
        to={`/ambition/production-action-plan/${year}/${department.id}`}
      >
        <div
          className="production-action-plan-container"
          style={{ flexDirection: "column", height: "209px" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              cursor: "pointer",
              gap: "33px",
            }}
          >
            <h5>Production</h5>
            <img src={deptIcon} alt="Add icon" width={50} height={50} />
          </div>
        </div>
      </Link>
      <div style={{ display: "flex" }}>
        <ProductionList
          className={"production-action-item"}
          newName={newEffort}
          setNewName={setNewEffort}
          handleSave={handleSaveEffort}
          efforts={efforts}
          link={`/ambition/production-action-plan/${year}/${department.id}`}
        />
      </div>
    </div>
  );
};
